import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, createBlock as _createBlock, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d2652700")
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "nav nav-tabs" }
const _hoisted_3 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Individual Plans ")
const _hoisted_5 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("New Flat Rate Plans ")
const _hoisted_7 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Family Plans ")
const _hoisted_9 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Business Plans ")
const _hoisted_11 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Activate Warranty ")
const _hoisted_13 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" FIG Extended Warranties ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Loading..")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Checkout = _resolveComponent("Checkout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_RegistrationSummary = _resolveComponent("RegistrationSummary")!
  const _component_ForceToCreatePartnerProperties = _resolveComponent("ForceToCreatePartnerProperties")!
  const _component_RequireToAcceptTerms = _resolveComponent("RequireToAcceptTerms")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("ul", _hoisted_2, [
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                (_ctx.hasPartnerSalesRegisterPlanAkkoPlansPermission ||
                  _ctx.hasPartnerSalesRegisterPlanPhonePlansPermission)
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN_INDIVIDUAL,
                      class: _normalizeClass([{
                  active: _ctx.isActive(
                    _ctx.RouteNames.HOME_REGISTER_NEW_PLAN_INDIVIDUAL,
                  ),
                }, "nav-link"]),
                      "aria-current": "page"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                _ctx.hasPartnerFlatRatePermission
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_FLAT_RATE_PLAN,
                      class: _normalizeClass([{
                  active: _ctx.isActive(_ctx.RouteNames.HOME_REGISTER_NEW_FLAT_RATE_PLAN),
                }, "nav-link"]),
                      "aria-current": "page"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                _ctx.isEnableHomePlanFeature &&
                _ctx.hasPartnerSalesRegisterPlanHomePlansPermission
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN_FAMILY,
                      class: _normalizeClass([{
                  active: _ctx.isActive(_ctx.RouteNames.HOME_REGISTER_NEW_PLAN_FAMILY),
                }, "nav-link"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                _ctx.hasPartnerSalesRegisterPlanBusinessPlansPermission &&
                _ctx.hasUserPartnerPortalAdminUsersPermissionForViewOrEdit
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN_BUSINESS,
                      class: _normalizeClass([{
                  active: _ctx.isActive(_ctx.RouteNames.HOME_REGISTER_NEW_PLAN_BUSINESS),
                }, "nav-link"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                _ctx.isEnableActivateWarrantyFeature &&
                _ctx.hasPartnerSalesRegisterPlanActivateWarrantyPermission &&
                _ctx.hasUserPartnerPortalAdminUsersPermissionForViewOrEdit
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN_WARRANTY,
                      class: _normalizeClass([{
                  active: _ctx.isActive(_ctx.RouteNames.HOME_REGISTER_NEW_PLAN_WARRANTY),
                }, "nav-link"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
                _ctx.isEnableExtendedWarrantyForFigFeature &&
                _ctx.hasPartnerSalesRegisterPlanActivateWarrantyForFigPermission &&
                _ctx.hasUserPartnerPortalAdminUsersPermissionForViewOrEdit
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN_WARRANTY_FOR_FIG,
                      class: _normalizeClass([{
                  active: _ctx.isActive(
                    _ctx.RouteNames.HOME_REGISTER_NEW_PLAN_WARRANTY_FOR_FIG,
                  ),
                }, "nav-link"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.hasLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_router_view)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      fallback: _withCtx(() => [
        _hoisted_16
      ]),
      _: 1
    })),
    (_ctx.goToCheckout)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_Checkout, {
              "coverage-selection": _ctx.coverageSelection.plans,
              discounts: _ctx.coverageSelection.discounts,
              "plan-interval": _ctx.interval,
              "coverage-type": _ctx.coverageTypeSelected,
              onCancelRegistration: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelRegistration()))
            }, null, 8, ["coverage-selection", "discounts", "plan-interval", "coverage-type"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!_ctx.registrationSummary)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_RegistrationSummary)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.forceToCreatePartnerProperties)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ForceToCreatePartnerProperties)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.requireToAcceptTerms)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_RequireToAcceptTerms)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}